import styled from 'styled-components';
import type { JSX } from 'react';
import type { HotspotColor } from './types';
import { useHotspotThemeColor } from './useHotspotThemeColor';

const StyledCircle = styled.circle<{ color: string }>`
  fill: ${({ color }) => color};
`;

type AnimatedSpotProps = {
  color: HotspotColor;
  opacity: string;
  radius: number;
};

export const AnimatedSpot = ({ color, opacity, radius }: AnimatedSpotProps): JSX.Element => {
  const spotColor = useHotspotThemeColor(color);

  return (
    <StyledCircle
      opacity={opacity}
      cx="26.8125"
      cy="26.8125"
      r={radius}
      color={spotColor}
    >
      <animate
        attributeName="opacity"
        values={`0;${opacity};0;`}
        dur="2s"
        repeatCount="9.5"
      />
    </StyledCircle>
  );
};
